export default __webpack_public_path__ + "static/media/hero-01.0a7bd892.jpg";